var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F66A3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9872 35.7083C19.5184 35.7083 19.1118 35.5362 18.7674 35.1919C18.4231 34.8474 18.251 34.4408 18.251 33.9721V20.7778C18.251 20.3091 18.4231 19.9025 18.7674 19.558C19.1118 19.2138 19.5184 19.0416 19.9872 19.0416H33.1814C33.6502 19.0416 34.0568 19.2138 34.4012 19.558C34.7455 19.9025 34.9176 20.3091 34.9176 20.7778V26.0729L39.0843 21.9062V32.8437L34.9176 28.677V33.9721C34.9176 34.4408 34.7455 34.8474 34.4012 35.1919C34.0568 35.5362 33.6502 35.7083 33.1814 35.7083H19.9872ZM19.9872 33.9721H33.1814V20.7778H19.9872V33.9721Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16.667 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPresentation);
export default __webpack_public_path__ + "static/media/video_presentation.cbfa4c8c8ad92a7938b5407a2ca76704.svg";
export { ForwardRef as ReactComponent };